import PropTypes from "prop-types";

/** An error line under a control that has no error slot of its own. */
function FieldError({ id, children }) {
  if (!children) return null;
  return (
    <p id={id} className="m-0 text-sm text-destructive">
      {children}
    </p>
  );
}

FieldError.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.string,
};

export default FieldError;
